module.exports = __webpack_public_path__ + "static/media/stanford.2409d6ca.png";